import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { BundlesTableRow } from '../models/bundles-table-row';

@Injectable({
  providedIn: 'root'
})
export class BundlesApiService {

  private serverUrl = environment.serverUrl;

  constructor(private http: HttpClient) { }

  getBundles(): Observable<BundlesTableRow[]> {
    return this.http.get<BundlesTableRow[]>(`${this.serverUrl}/api/Bundle`);
  }
}
